import React from "react";

import { appConstants } from "../../config/app-constants";

type Props = {};

const IFSCCodeHint: React.FC<Props> = (props: Props) => {
	return (
		<>
			<section className="text-center">
				<h5 className="text-start">
					The IFSC Code is an 11-digit alpha-numeric code. The code is unique for every branch of
					the bank.
				</h5>

				<img
					src={`${appConstants.basePath}/assets/images/hints/ifsc-breakdown.svg`}
					alt="IFSC"
					className="img-fluid d-block mx-auto my-4"
				/>

				<a
					href={`${appConstants.basePath}/assets/files/bank-ifsc-code-list.xlsx`}
					download="bank-ifsc-code-list"
					target="_blank"
					rel="noreferrer"
					className="leading-para"
				>
					Click here to see full list of IFSC codes
				</a>
			</section>
		</>
	);
};

export default IFSCCodeHint;
